import React from 'react';
import { StyledSvg, iconGenerator } from '../Icon';
const BudgePaidIcon = ({ size, deg }) => (React.createElement(StyledSvg, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", size: size, deg: deg },
    React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "#349172", transform: "translate(3 3)" },
        React.createElement("path", { fill: "#349172", d: "M13.481 7.5H.52a6.5 6.5 0 0 0 12.962 0z" }),
        React.createElement("circle", { cx: "7", cy: "7", r: "6.5" }))));
export const BudgePaid = iconGenerator(BudgePaidIcon);
//# sourceMappingURL=BudgePaid.js.map